import React from "react";
import logo from "../../Images/lo.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function ({ isTrue }) {
  // const navigate = useNavigate();
  // const clickHandler = () => {
  //   navigate("/");
  // }
  return (
    <div>
      {/* <Link to="https://www.actualizecenter.com/"> */}
      <span>
        {" "}
        <a
          href="https://www.actualizecenter.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          <img src={logo} alt="" className="w-2/12" />
        </a>
      </span>
      <span> {/* <a href="/"></a> */}</span>
      {/* <img onClick={clickHandler} src={logo} alt="" className="w-2/12" /> */}
      {/* </Link> */}
    </div>
  );
}
